import interview_icon from '../assets/interview_icon.png';
import revision_icon from '../assets/revision_icon.png';
import pdf_icon from '../assets/pdf_icon.png';
import book_icon from '../assets/book_icon.png';
import sound_icon from '../assets/sound_icon.png';
import arrow from '../assets/yellow_arrow.png';
export default function Features(props) {
    return (
        <div id={props.id}>
            <div className="line-container">
                    <span className="horizontal-line line-left"></span>
                    <div className="pill-box">
                        What do I get?
                    </div>
                    <span className="horizontal-line line-right"></span>
                </div>
            <div className="features-container">
                <h1 className="features-title">You get much more than a book</h1>
                <h2 className="features-subtitle">We won't nickel-and-dime you. Each chapter encompasses a full experience start-to-finish.</h2>
                <div className="feature-items-container">
                    <div className="feature-item">
                        <img src={interview_icon} />
                        <h3>A One Hour Interview</h3>
                        <p>Each chapter is based on a one hour interview we conduct with you over Zoom.</p>
                    </div>
                    <div className="feature-item">
                        <img src={revision_icon} />
                        <h3>A Round of Revisions</h3>
                        <p>Telling your story is personal, so we give you the option to offer feedback on our draft.</p>
                    </div>
                    <div className="feature-item">
                        <img src={pdf_icon} />
                        <h3>A PDF to Share</h3>
                        <p>We'll put your story in a PDF that you can share with friends and family.</p>
                    </div>
                    <div className="feature-item">
                        <img src={book_icon} />
                        <h3>Two Printed Booklets</h3>
                        <p>We print two copies of your chapter as beautiful hard-cover books—one for your bookshelf and one as a gift.</p>
                    </div>
                    <div className="feature-item">
                        <img src={sound_icon} />
                        <h3>An Audio Chapter</h3>
                        <p>Maybe reading's not your thing. No problem, you’ll be able to listen to your chapter too.</p>
                    </div>
                </div>
                <hr className="feature-divider" />
                <span className="chapter-price">$249 per chapter</span>
            </div>
            <img src={arrow} className="main-intro-yellow-arrow" />
        </div>
    )
}